enum DeductionType {
  NORMAL = "Normal"
}

export default DeductionType;
